import script from "./TaskProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskProgress.vue?vue&type=script&setup=true&lang=js"

import "./TaskProgress.vue?vue&type=style&index=0&id=259511a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259511a1"]])

export default __exports__